export default __webpack_public_path__ + "static/media/0x614389eaae0a6821dc49062d56bda3d9d45fa2ff.aec47f6e.webp";